export default [
  {
    name: "New Year's Day",
    date: "2022-01-01"
  },
  {
    name: "New Year's Day (OBV)",
    date: '2022-01-03'
  },
  {
    name: "Islander Day",
    date: "2022-02-21",
    appliesTo: ['PE']
  },
  {
    name: "Louis Riel Day",
    date: "2022-02-21",
    appliesTo: ['MB']
  },
  {
    name: "Nova Scotia Heritage Day",
    date: "2022-02-21",
    appliesTo: ['NS']
  },
  {
    name: "Family Day",
    date: "2022-02-21",
    appliesTo: ['AB', 'BC', 'NB', 'ON', 'SK']
  },
  {
    name: "Good Friday",
    date: "2022-04-15",
    doesNotApplyTo: ['QC']
  },
  {
    name: "Easter Monday",
    date: "2022-04-18",
    appliesTo: ['QC']
  },
  {
    name: "Victoria Day",
    date: "2022-05-23",
    doesNotApplyTo: ['NB', 'NS', 'NL']
  },
  {
    name: "National Aboriginal Day",
    date: "2022-06-21",
    appliesTo: ['NT']
  },
  {
    name: "Discovery Day (NL)",
    date: "2022-06-24",
    appliesTo: ['NL']
  },
  {
    name: "St. Jean Baptiste Day",
    date: "2022-06-24",
    appliesTo: ['QC']
  },
  {
    name: "Canada Day",
    date: "2022-07-01"
  },
  {
    name: "Nunavut Day",
    date: "2022-07-09",
    appliesTo: ['NU']
  },
  {
    name: "Civic Holiday",
    date: "2022-08-01",
    appliesTo: ['BC', 'SK', 'ON', 'NB', 'NU', 'NT']
  },
  {
    name: "Alberta Heritage Day",
    date: "2022-08-01",
    appliesTo: ['AB']
  },
  {
    name: "Discovery Day (YT)",
    date: "2022-08-15",
    appliesTo: ['YT']
  },
  {
    name: "Labour Day",
    date: "2022-09-05"
  },
  {
    name: "Thanksgiving",
    date: "2022-10-10",
    doesNotApplyTo: ['NB', 'NS', 'NL']
  },
  {
    name: "Remembrance Day",
    date: "2022-11-11",
    doesNotApplyTo: ['MB', 'ON', 'QC', 'NS']
  },
  {
    name: "Christmas Day",
    date: "2022-12-25"
  },
  {
    name: "Boxing Day",
    date: "2022-12-26",
    appliesTo: ['ON']
  }
];
